import { render, staticRenderFns } from "./ViewAllMaterials.vue?vue&type=template&id=f2b658bc&scoped=true"
import script from "./ViewAllMaterials.vue?vue&type=script&lang=js"
export * from "./ViewAllMaterials.vue?vue&type=script&lang=js"
import style0 from "./ViewAllMaterials.vue?vue&type=style&index=0&id=f2b658bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b658bc",
  null
  
)

export default component.exports